export const never = undefined;
export const unknown = undefined;

